import '@ant-design/v5-patch-for-react-19';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { createStore, applyMiddleware, compose } from 'redux';
import { thunk } from 'redux-thunk';
import './index.css';
import App from './App';
import './i18n';
import * as serviceWorker from './serviceWorker';
import reducer from './store/reducer';
import { initKeycloak } from './services/AuthService';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(reducer, composeEnhancers(applyMiddleware(thunk)));

// Create root for React 18+ rendering
const root = ReactDOM.createRoot(document.getElementById('root'));

// Initialize Keycloak and render app after authentication check
const renderApp = () => {
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <Suspense fallback={<div>Loading</div>}>
          <BrowserRouter basename="/lode">
            <App />
          </BrowserRouter>
        </Suspense>
      </Provider>
    </React.StrictMode>
  );
};

// Initialize Keycloak
initKeycloak(renderApp);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
serviceWorker.unregister();